export const WINNING_POINTS = 20;
export const VOTE_POINT_COUNT = 3;
export const MAX_WORD_LENGTH = 150;
export const DEFAULT_CLIENT_ID = 1;
